import { TreeNode } from 'Components/Primitives/Tree/Tree.types';

export const getTreeDepths = (treeNodes: TreeNode[]): number => {
  if (!treeNodes || treeNodes.length === 0) return 0;

  const getNodeDepth = (node: TreeNode | null | undefined): number => {
    if (!node) return 0;
    if (!node.children || node.children.length === 0) return 1;
    const childDepths = node.children.map((child) => getNodeDepth(child)).filter((depth) => depth > 0);
    return 1 + (childDepths.length > 0 ? Math.max(...childDepths) : 0);
  };

  const depths = treeNodes.map((rootNode) => getNodeDepth(rootNode)).filter((depth) => depth > 0);
  return depths.length > 0 ? Math.max(...depths) : 0;
};

export const getTreeValues = (treeNodes: TreeNode[]): (string | number)[] => {
  const leafValues: (string | number)[] = [];
  if (!treeNodes || treeNodes.length === 0) return leafValues;

  const stack = [...treeNodes];
  while (stack.length > 0) {
    const currentNode = stack.pop()!;

    if (!currentNode.children || currentNode.children.length === 0) {
      leafValues.push(currentNode.value);
    } else {
      for (let i = currentNode.children.length - 1; i >= 0; i--) {
        stack.push(currentNode.children[i]);
      }
    }
  }

  return leafValues;
};

export const getTreeSelectedValues = (selected: (string | number)[], treeNodes: TreeNode[]): (number | string)[] => {
  const getTreeNodeSelectedValues = (nodes: TreeNode[]): (string | number)[] =>
    nodes.reduce((acc: (string | number)[], tn) => {
      if (selected.includes(tn.value)) {
        acc = [...acc, ...(tn.children.length > 0 ? getTreeValues(tn.children) : [tn.value])];
      } else if (tn.children.length > 0) {
        acc = [...acc, ...getTreeNodeSelectedValues(tn.children)];
      }
      return acc;
    }, []);

  return getTreeNodeSelectedValues(treeNodes);
};
